<!-- The trigger only opens the overlay. It is a button, not a link: the sole navigation to
     the legacy profile page is the Profile item inside the overlay. -->
<button
  #profileMenuTrigger
  type="button"
  [id]="ids.trigger"
  class="user-profile-trigger flex items-center gap-2"
  aria-haspopup="menu"
  [attr.aria-expanded]="open()"
  [attr.aria-label]="triggerLabel()"
  (click)="toggle($event)"
>
  <!-- p-avatar sizes its root from the avatar design tokens in both image and icon mode,
       so the circle occupies identical space either way and the row does not shift between
       users or when a slow photo request resolves.

       icon and image are bound exclusively rather than both at once: p-avatar's template
       resolves label, then icon, then image, so an always-present icon would win and the
       photo would never render. -->
  <!-- alt="" via passthrough because p-avatar's template has no alt binding, and the photo
       is decorative here: the button's aria-label already names the user, so an unlabelled
       <img> would just repeat it as noise to a screen reader. -->
  <p-avatar
    shape="circle"
    [image]="photoSrc() ?? undefined"
    [icon]="photoSrc() ? undefined : 'pi pi-user'"
    [pt]="{ image: { alt: '' } }"
    (onImageError)="onPhotoError()"
  />

  <!-- Hidden below 991px so the circle alone is the trigger on mobile. `display: none`
       removes it from the accessibility tree too, which is why the button carries an
       explicit aria-label rather than relying on this text. -->
  <span class="user-profile-name hidden desktop:inline-block">{{
    displayName()
  }}</span>

  <i
    class="pi user-menu-chevron"
    [class.pi-chevron-up]="open()"
    [class.pi-chevron-down]="!open()"
    aria-hidden="true"
  ></i>
</button>

<p-menu
  #menu
  [id]="ids.overlay"
  [model]="menuItems()"
  [popup]="true"
  appendTo="body"
  styleClass="user-profile-overlay"
  (onShow)="onShow()"
  (onHide)="onHide()"
/>
